import { lazy } from 'react';

const APIAccessPage = lazy(() => import('./components/APIAccessPage'));
const ComicPage = lazy(() => import('./components/ComicPage'));
const CartographerPage = lazy(() => import('./components/CartographerPage'));
const SwingPage = lazy(() => import('./components/SwingPage'));
const HermesPage = lazy(() => import('./components/HermesPage'));
const MascotPage = lazy(() => import('./components/MascotPage'));
const PosePage = lazy(() => import('./components/PosePage'));
const CharacterGenerationPage = lazy(
  () => import('./components/CharacterGenerationPage'),
);
const MotionLibraryPage = lazy(() => import('./components/MotionLibraryPage'));

export const products = [
  {
    name: 'API',
    title: 'Workflow Scaling\n and Automation',
    slug: 'api-access',
    page: <APIAccessPage />,
    useLightText: false,
    comingSoonText: '',
  },
  {
    name: 'Comic',
    title: 'AI Performance\n Capture',
    slug: 'comic-ai-video-motion-capture',
    page: <ComicPage />,
    useLightText: true,
    comingSoonText: '',
  },
  {
    name: 'Swing',
    title: 'Motion Generation',
    slug: 'swing-motion-generation',
    page: <SwingPage />,
    useLightText: false,
    comingSoonText: '',
  },
  {
    name: 'Hermes',
    title: 'Motion Blending & Editing',
    slug: 'hermes-smart-in-between',
    page: <HermesPage />,
    useLightText: true,
    comingSoonText: '',
  },
  {
    name: 'Mascot',
    title: 'Video Capture to 2D Character Animation',
    slug: 'mascot',
    page: <MascotPage />,
    useLightText: true,
    comingSoonText: '',
  },
  {
    name: 'Pose',
    title: 'Character Rendering from Pose',
    slug: 'pose-render',
    page: <PosePage />,
    useLightText: true,
    comingSoonText: '',
  },
  {
    name: 'Character Generation',
    title: 'Image or Text-to-3D Characters',
    slug: 'character-generation',
    page: <CharacterGenerationPage />,
    useLightText: false,
    comingSoonText: '',
  },
  {
    name: 'Motion Library',
    title: 'Enterprise-Scale Motion Library',
    slug: 'motion-library',
    page: <MotionLibraryPage />,
    useLightText: false,
    comingSoonText: '',
  },
  {
    name: 'Cartographer',
    title: 'Universal Motion Retargeting',
    slug: 'cartographer',
    page: <CartographerPage />,
    useLightText: true,
    comingSoonText: '',
  },
] as const;
